export default "__VITE_ASSET__xMtmX$UM__"